import { EllipseText } from '@/components/EllipseText/EllipseText'
import { DataRow } from '@/components/Table/types'

type Props = {
  record: DataRow
}

export const EllipseTextTableRow = ({ record }: Props) => <EllipseText title={record?.origName} />
